import Head from 'next/head';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { IntlKeys, IntlKeysType } from '../../constants/IntlKeys';
import { createUseStyles } from '../../hooks/jss';

const useStyles = createUseStyles(theme => ({
  headerContainer: {
    fontSize: '36px',
    width: '100%',
    fontWeight: theme.ux.textHeading.fontWeight
  }
}));

type Props = {
  titleKey: IntlKeysType;
  hideTitle?: boolean;
};

export function PageTitle({ titleKey, hideTitle = false }: Props) {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <>
      <Head>
        <title>{intl.formatMessage({ id: titleKey })}</title>
      </Head>

      {!hideTitle && (
        <div className={classes.headerContainer}>
          <FormattedMessage id={IntlKeys.HTML_PAGE_TITLE} />
        </div>
      )}
    </>
  );
}
